import { Link, Stack, Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles()((theme: Theme) => ({
  stack: {
    position: 'relative',
    zIndex: 1
  },
  link: {
    // @ts-ignore
    color: theme.palette.gold.main,
    flex: 1,
    whiteSpace: 'nowrap'
  }
}))

export default function Footer(): JSX.Element {
  const { classes } = useStyles()

  return (
    <Stack className={classes.stack}>
      <Link
        color='textPrimary'
        component={RouterLink}
        textAlign='left'
        to={
          '/Client Agreement - Goldie Vaults Limited & Goldie Club Nominee Jan 2026.pdf'
        }
        underline='hover'
        variant='body1'
        className={classes.link}
        target='_blank'
      >
        Terms and Conditions
      </Link>
      <Link
        color='textPrimary'
        component={RouterLink}
        textAlign='left'
        to={'/GOLDIE Privacy Policy 2026.pdf'}
        underline='hover'
        variant='body1'
        className={classes.link}
        target='_blank'
      >
        Privacy Policy
      </Link>
    </Stack>
  )
}
